import React, { ReactNode } from "react";
import { Box, BoxProps } from "@UI/Components/Box/Box";
import { Card } from "@UI/Components/Card/Card";
import { Image } from "@UI/Components/Image/Image";

export interface RecommendationCardProps extends Omit<BoxProps, "css"> {
  children?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  coverImage: string;
  coverFallbackSrc?: string;
  coverAlt?: string;
  coverHeight?: string | number;
  href?: string;
}

export const RecommendationCard = ({
  children,
  header,
  footer,
  coverImage,
  coverFallbackSrc,
  coverAlt = "Cover image",
  coverHeight = "150px",
  href,
  ...boxProps
}: RecommendationCardProps) => {
  return (
    <Box
      as={href ? ("a" as const) : undefined}
      // some paths might already include a leading slash, so we want to avoid double slashes
      href={href ? (href.startsWith("/") ? href : `/${href}`) : undefined}
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      alignSelf="stretch"
      flex="1"
      borderRadius="3xl"
      overflow="hidden"
      gap="0"
      boxShadow="rt-lg"
      _hover={{ boxShadow: "sm", textDecoration: "none" }}
      cursor="pointer"
      textDecoration="none"
      color="inherit"
      {...boxProps}
    >
      <Image
        src={coverImage}
        fallbackSrc={coverFallbackSrc}
        alt={coverAlt}
        objectFit="cover"
        width="100%"
        height={coverHeight}
        flexShrink={0}
        backgroundColor="gray.300"
        zIndex="1"
      />
      <Card
        marginTop="-4"
        padding="4"
        backgroundColor="white"
        rounded="3xl"
        width="100%"
        zIndex="2"
        flex="1"
        gap="1"
        shadow="none"
        header={header}
        footer={footer}
      >
        {children}
      </Card>
    </Box>
  );
};
